import { PackageScanModesFormBaseDataProvider } from './PackageScanModesFormBaseDataProvider';
import { ScanModeData } from '../types/ScanModeData';
import { ScanTypes } from '../types/ScanTypes';
import { BaseWebComponentTranslator } from '../../../../framework/BaseWebComponentTranslator';

export class PackageScanModesFormGzDataProvider extends PackageScanModesFormBaseDataProvider {
  private stringsTranslator: BaseWebComponentTranslator = BaseWebComponentTranslator.getInstance();

  public getScanModes(): ScanModeData[] {
    return [
      {
        value: ScanTypes.PrivateCloud,
        title: this.stringsTranslator.getScanTypes(ScanTypes.PrivateCloud),
      },
      {
        value: ScanTypes.Cloud,
        title: this.stringsTranslator.getScanTypes(ScanTypes.Cloud),
      },
      {
        value: ScanTypes.Local,
        title: this.stringsTranslator.getScanTypes(ScanTypes.Local),
      },
    ];
  }

  public getSimpleScanModes(): ScanModeData[] {
    return [
      {
        value: ScanTypes.Cloud,
        title: this.stringsTranslator.getScanTypes(ScanTypes.Cloud),
      },
      {
        value: ScanTypes.Local,
        title: this.stringsTranslator.getScanTypes(ScanTypes.Local),
      },
    ];
  }

  public getEc2ScanModes(): ScanModeData[] {
    return [
      {
        value: ScanTypes.PrivateCloud,
        title: this.stringsTranslator.getScanTypes(ScanTypes.PrivateCloud),
      },
    ];
  }
}
